/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Link, useNavigate } from "react-router-dom";
import * as formik from "formik";
import * as yup from "yup";
import {
  useUserRegister,
  useUserSignIn,
} from "../../../../../api/mutations/auth.mutation";
import { signInSuccess } from "../../../../../store";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../store/hook";
import * as RoleSelector from "src/store/role/selector";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { useState } from "react";

function Setting() {
  const { Formik } = formik;

  const schema = yup.object().shape({
    email: yup.string().required("Please enter your email"),
    password: yup.string().required("Please enter your password"),
    rememberMe: yup.bool(),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = useAppSelector(RoleSelector.selectUserRole);

  const userLoginMutation = useUserSignIn({
    onSuccess: (data) => {
      dispatch(signInSuccess("token"));
      navigate("/u");
    },
    onError: (error) => {
      if (error.message) {
      }
    },
    successMessage: "Login Successful!",
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  const onSignIn = (data) => {};

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSignIn}
      initialValues={{
        email: "",
        password: "",
        rememberMe: false,
      }}
    >
      {({ handleSubmit, handleChange, values, touched, errors }) => (
        <Form noValidate onSubmit={handleSubmit} className="mt-5">
          <Row className="mb-2">
            <h3 className="mb-3">Setting</h3>
            <Form.Group
              as={Col}
              controlId="validationFormikEmail"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Username or Email Address
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="Your Full Name"
                name="email"
                value={values.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="validationFormikPassword"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                New Password
              </Form.Label>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                value={values.password}
                onChange={handleChange}
                isInvalid={!!errors.password}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleTogglePassword}
                className="mt-2"
              >
                {showPassword ? "Hide" : "Show"} Password
              </Button>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group
              as={Col}
              controlId="validationFormikPassword"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Confirm Password
              </Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                name="password"
                value={values.password}
                onChange={handleChange}
                isInvalid={!!errors.password}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-end">
            <Button
              variant="success"
              type="submit"
              className="btn btn-success mt-4 fw-semibold text-uppercase"
            >
              Change Password
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Setting;
